import { type AbsoluteRouteOnlyPath, type AbsoluteRoutePath, getBreadcrumbConfig, isRouteParent } from '../routing'
import { useRouting } from '../routing'
import { getNavigationConfig } from './Config'

type MenuGroups = [AbsoluteRouteOnlyPath[], AbsoluteRouteOnlyPath[]]

export const useNavigationRouting = useRouting.extend(
    (RoutingHook) =>
        class extends RoutingHook {
            getCurrentSection (): AbsoluteRoutePath {
                const currentPath = this.state.path
                const { parents } = getBreadcrumbConfig(currentPath)

                /**
                 *  Breadcrumbs are sorted from children to parent,
                 *  so we take the last parent, which is the top parent.
                 */
                const [topParent] = parents.slice(-1)
                return topParent ? topParent.id : currentPath
            }

            getSectionMenuGroups (section: AbsoluteRoutePath, pool: readonly AbsoluteRouteOnlyPath[]): MenuGroups {
                return pool.reduce<MenuGroups>(
                    (prev, route) => {
                        // Check if the child route is not part of the section, then skip assigning the route
                        if (!isRouteParent(route, section)) {
                            return prev
                        }
                        // Check if a child route should be in the extra menu, then add it to the second list
                        if (getNavigationConfig(route, 'isExtraMenu')) {
                            prev[1].push(route)
                        } else {
                            // otherwise, add it to the main menu
                            prev[0].push(route)
                        }
                        return prev
                    },
                    [[], []]
                )
            }

            getSideMenuGroups (pool: readonly AbsoluteRouteOnlyPath[]): MenuGroups {
                return this.getSectionMenuGroups(this.getCurrentSection(), pool)
            }
        },
    'useNavigationRouting'
)
